import React, { Component } from 'react'
import { BaseEntityPage } from '../BaseEntityPage';
import { ApiHelper } from '../../helpers/ApiHelper';
import { Helper } from '../../helpers/Helper';
import { AppHelper } from '../../../helpers/AppHelper';
import { css } from 'aphrodite';
import { AppStyles } from '../../../styles/AppTheme';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { Button } from '@material-ui/core';

export class Respond extends BaseEntityPage {
  constructor(props) {
    super(props)
    this.pageTitle = 'Respond'
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['questionRess'], { }) },
    ]
  }
  onFetchSuccess(results) {
    console.log('results:', results)
    // this.formDefinition = results[0].fieldDef
    // const options = Helper.sortDictArray(Helper.dictToArray(results[0].options) || [])
    // this.setState({
    //   items: options
    // })
  }
  renderCustomReady = () => {
    return (
      <div>
        <Button
          margin='normal' color='primary'
          onClick={this.moveToNextQuestion}
        >
          Next
        </Button>
      </div>
    )
  }

  moveToNextQuestion = () => {

  }
}


// WEBPACK FOOTER //
// ./src/common/components/quizresponder/Respond.js